import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { Route, Routes, Navigate } from "react-router-dom";
import { connect } from "react-redux";

// Routes
import { adminRoutes, farmRoutes, authRoutes } from "./routes/allRoutes";

// Middlewares & Layouts
import Authmiddleware from "./routes/middleware/Authmiddleware";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Styles
import "./assets/scss/theme.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Fake backend
import fakeBackend from "./helpers/AuthType/fakeBackend";
fakeBackend();

const App = (props) => {
  // role must be STATE not a direct read
  const [role, setRole] = useState(sessionStorage.getItem("role"));

  // Listen for login/logout and update React state
  useEffect(() => {
    const handler = () => {
      setRole(sessionStorage.getItem("role"));
    };

    window.addEventListener("roleChanged", handler);

    return () => window.removeEventListener("roleChanged", handler);
  }, []);

  // Which route set to render?
  const finalRoutes =
    role === "admin"
      ? adminRoutes
      : role === "farm_user"
        ? farmRoutes
        : authRoutes;

  // Which layout to apply
  const Layout = VerticalLayout;

  return (
    <React.Fragment>
      <ToastContainer />

      <Routes>
        {/* Public / Non-auth routes */}
        {authRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}

        {/* Logged-in routes */}
        {finalRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware allowedRoles={['admin', 'farm_user']}>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
          />
        ))}

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
